import { inject } from '@angular/core';
import { Store, select } from '@ngrx/store';

import { DotCMSUveLanguageConfig } from 'ish-core/models/dot-cms-uve/dot-cms-uve-config.model';
import { applyConfiguration, getDotCmsLanguageConfiguration } from 'ish-core/store/core/configuration';

/**
 * Routes only to the page if the configured feature toggle at the route is switched on
 */
export function dotCmsUveGuard() {
  const store = inject(Store);
  let languageConfig: DotCMSUveLanguageConfig;
  let languageId!: number;

  store.pipe(select(state => state.router?.state?.queryParams?.language_id)).subscribe(id => {
    languageId = id;
  });

  store.pipe(select(getDotCmsLanguageConfiguration)).subscribe(config => {
    languageConfig = config;
  });

  const languageMap = languageConfig;
  const matchedLocale = Object.keys(languageMap).find(value => languageConfig[value] == languageId);

  if (matchedLocale) {
    store.dispatch(
      applyConfiguration({
        lang: matchedLocale,
      })
    );
  }

  return true;
}
